// composables/useConfirm.ts
import type { App } from 'vue'
import { ref } from 'vue'

export interface ConfirmOptions {
  title?: string
  message: string
  confirmText?: string
  cancelText?: string
}

interface ConfirmState {
  isVisible: boolean
  options: Required<ConfirmOptions>
  resolvePromise: ((value: boolean) => void) | null
}

// 全局状态，支持在任何组件中使用
const confirmState = ref<ConfirmState>({
  isVisible: false,
  options: {
    title: '确认',
    message: '',
    confirmText: '确定',
    cancelText: '取消',
  },
  resolvePromise: null,
})

export const useConfirm = () => {
  const showConfirm = (opts: ConfirmOptions): Promise<boolean> => {
    // 合并默认选项
    confirmState.value.options = {
      title: '确认',
      confirmText: '确定',
      cancelText: '取消',
      ...opts,
    }

    confirmState.value.isVisible = true

    return new Promise((resolve) => {
      confirmState.value.resolvePromise = resolve
    })
  }

  const handleConfirm = () => {
    confirmState.value.isVisible = false
    confirmState.value.resolvePromise?.(true)
    confirmState.value.resolvePromise = null
  }

  const handleCancel = () => {
    confirmState.value.isVisible = false
    confirmState.value.resolvePromise?.(false)
    confirmState.value.resolvePromise = null
  }

  return {
    // 响应式状态
    isVisible: confirmState.value.isVisible,
    options: confirmState.value.options,
    // 方法
    showConfirm,
    handleConfirm,
    handleCancel,
    // 直接暴露状态用于模板
    confirmState,
  }
}

// 可选：提供全局安装方法
export const ConfirmPlugin = {
  install(app: App) {
    app.config.globalProperties.$confirm = useConfirm().showConfirm
  },
}
